import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Translate from '@client/components/shared/translation/Translate';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { getCountry } from '@client/redux/modules/countrySelection/selectors';
import { saveCountry } from '@client/redux/modules/countrySelection/actions';
import {
    COUNTRY_CODE_FI,
    COUNTRY_CODE_SE,
    COUNTRY_CODE_DK,
} from '@client/config/constants';

import InfoBox from '../../../shared/InfoBox';
import CountrySelectionButton from '../CountrySelectionButton';
import styles from './styles.scss';

export class CountrySelection extends React.Component {
    static propTypes = {
        preferredCountry: PropTypes.string,
        saveCountry: PropTypes.func.isRequired
    };

    render() {
        const { preferredCountry } = this.props;
        if (preferredCountry) {
            return null;
        }

        return (
            <TranslationsScope path="countrySelection">
                <InfoBox title="title" sticky noCloseIcon>
                    <div styleName="description">
                        <Translate message="description" />
                    </div>
                    <div styleName="selection-section">
                        { this.countries.map((country) => (
                            <CountrySelectionButton key={country.code} onButtonClick={this.onClick} country={country} />
                        ))}
                    </div>
                </InfoBox>
            </TranslationsScope>
        );
    }

    onClick = (country, message) => (
        country && this.props.saveCountry({
            country: country.code,
            successMessage: message
        })
    );

    countries = [{
        code: COUNTRY_CODE_SE,
        name: 'Sweden',
        icon: 'icon-flag-se'
    },
    {
        code: COUNTRY_CODE_FI,
        name: 'Finland',
        icon: 'icon-flag-fi'
    },
    {
        code: COUNTRY_CODE_DK,
        name: 'Denmark',
        icon: 'icon-flag-dk'
    }];
}

const mapStateToProps = (state) => ({
    preferredCountry: getCountry(state)
});

const mapDispatchToProps = {
    saveCountry,
};

export const injectStyles = (component) => CSSModules(component, styles, { allowMultiple: true });

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectStyles
)(CountrySelection);
